export default "__VITE_ASSET__518ab4cd__"